
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/id/find",
      function () {
        return require("private-next-pages/id/find/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/id/find"])
      });
    }
  